import { TaskName } from '@/common/constants/taskNames.constants';
import { TaskState } from '@schema';
import i18n from '@/common/i18n';
import { store } from '@/common/root';
import type { TaskMap } from '@/common/store/modules/tasks/tasksNotificationMapper';

const useNodes = (payload) => {
  const { nodes = [] } = payload || {};
  const node = store.getters['locations/getNodeById'](nodes[0]?.id);
  const count = nodes.length;

  return {
    name: node?.name || '',
    count
  };
};

const taskMap: TaskMap = {
  [TaskName.S3_CREATE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('S3 storage created'),
      message: i18n.t('S3 storage successfully created')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Creating "S3 storage"...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Failed to create S3 storage'),
      message: error
    })
  },
  [TaskName.S3_NODE_ASSIGN]: {
    [TaskState.SUCCESS]: ({ payload }) => {
      const { name, count } = useNodes(payload);
      return {
        title: i18n.tc('Node successfully added to S3 storage|Nodes successfully added to S3 storage', count),
        message: i18n.tc(
          'Node "{name}" successfully added|{count} nodes successfully added',
          count,
          { name, count }
        )
      };
    },
    [TaskState.RUNNING]: ({ payload }) => {
      const { name, count } = useNodes(payload);
      return {
        message: i18n.tc(
          'Adding node "{name}" to S3 storage...|Adding {count} nodes to S3 storage...',
          count,
          { name, count }
        )
      };
    },
    [TaskState.FAILED]: ({ error, event }) => ({
      title: i18n.tc('Error adding node to S3 storage|Error adding nodes to S3 storage', event.nodeNames.length),
      message: error
    })
  },
  [TaskName.S3_GEO_REPLICATION_ADD]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Datacenter added to S3 storage'),
      message: i18n.t('Datacenter successfully added to S3 storage')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Adding datacenter to S3 storage...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error adding datacenter to S3 storage'),
      message: error
    })
  },
  [TaskName.S3_GEO_REPLICATION_DELETE]: {
    [TaskState.SUCCESS]: () => ({
      title: i18n.t('Datacenter deleted from S3 storage'),
      message: i18n.t('Datacenter successfully deleted from S3 storage')
    }),
    [TaskState.RUNNING]: () => ({
      message: i18n.t('Deleting datacenter from S3 storage...')
    }),
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error deleting datacenter from S3 storage'),
      message: error
    })
  },
  [TaskName.S3_USER_STATE]: {
    [TaskState.FAILED]: ({ error }) => ({
      title: i18n.t('Error updating s3 user state'),
      message: error
    })
  }
};

export default taskMap;
